<template>
  <v-container fluid class="px-0 py-0">
    <CoreBomSheetTable
        title=""
        dto-list-query="BomSheetMatchListQueryDTO"
        :store-name="storeTableName"
        :height="height - 260"
        :headers="headers"
        :detail-store-name="storeDetailName"
        :hide-default-footer="true"
        :hide-default-header="true"
        :show-select="true"
        :main-validator="false"
        :row-background="rowBackground"
    ></CoreBomSheetTable>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreBomDetail from "@/components/CoreComponent/Bom/CoreBomDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CoreBomSheetTable from "@/components/CoreComponent/BomSheet/CoreBomSheetTable";
import {useDetailStore} from "@/components/Common/CommonDetail";

export default {
  name: "CoreBomMatchTable",

  props: {
    height: {default: null},
    product_uid: {default: null}
  },

  components: {
    CommonTable,
    CoreBomDetail,
    BaseFieldCheck,
    CoreBomSheetTable,
  },
  
  watch: {
    product_uid: {
      handler(newValue, oldValue) {
        // console.log('watch BomDetail uidItem', newValue, oldValue)
        this.filterTable()
        this.storeDetail.parentUid = this.product_uid
      },
      deep: true
    },
  },

  methods: {
    rowBackground(item) {
      if (item.import_error_status === 'ERROR')
        return 'red lighten-4'
      if (item.import_error_status === 'WARNING')
        return 'orange lighten-4'
      if (item.import_error_status === 'SUCCESS')
        return 'green lighten-4'
    },
    filterTable() {
      this.storeTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'product__uid', value: this.product_uid, enable: !!this.product_uid},
          {param_compare: 'product__uid', value: null, enable: !this.product_uid},
        ],
        enable: true,
      }
    },
  },


  mounted() {
    this.storeDetail = useDetailStore(this.storeDetailName)()
    this.storeAggregate = useAggregateStore()
    this.storeTable = useTableStore(this.storeTableName)()
    this.storeTable.options.itemsPerPage = -1
    this.storeTable.options.sortBy = ['order']
    this.storeTable.options.sortDesc = [true]
    this.storeTable.footerProps = {'items-per-page-options': [5, 20, 50, 100, 200, -1]}
    this.filterTable()
  },

  data() {
    return {
      storeDetail: null,
      storeDetailName: uuidv4(),
      storeAggregate: null,
      storeTable: null,
      storeTableName: uuidv4(),
      headers: [
        {text: '', value: 'order', sortable: true, filterable: true, divider: true, width: 10, type: 'drag'},
        {
          text: 'Status',
          value: 'row_match_statuses',
          sortable: false,
          filterable: true,
          divider: true,
          align: 'center',
          width: 10,
          type: 'status'
        },
        {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 25},
        // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
        {text: 'Do not place', value: 'do_not_place', sortable: false, filterable: true, divider: true, type: 'bool', align: 'center', color: 'green', width: 10},
        {
          text: 'Provided by customer',
          value: 'provided_by_customer',
          sortable: false,
          filterable: true,
          divider: true,
          type: 'bool',
          align: 'center',
          color: 'green',
          width: 10
        },
        {text: 'QTY', value: 'qty', sortable: true, filterable: true, divider: true, align: 'right', width: 60},
        {
          text: 'Designator',
          value: 'designator',
          sortable: true,
          align: 'center',
          divider: true,
          width: 150,
          type: 'text'
        },
        {text: 'Description', value: 'description', sortable: false, divider: true, width: 150, type: 'text'},
        {text: 'MPN', value: 'mpn', sortable: false, align: 'center', divider: true, width: 210},
        {text: 'Original article', value: 'article', sortable: false, align: 'right', divider: true, width: 50},
        {text: 'Customer article', value: 'customer_article', sortable: false, align: 'left', divider: true, width: 50},
        // {text: '', value: 'component_search', sortable: false, align: 'center', divider: true, width: 80},
        {text: 'Article', value: 'component__article', sortable: true, align: 'end', divider: true, width: 50},
        {text: 'Alias', value: 'component__alias', sortable: true, align: 'right', divider: true, width: 210},
        {
          text: 'Type',
          value: 'component__case_package__type',
          sortable: false,
          align: 'center',
          divider: true,
          width: 70
        },
        {
          text: 'Category',
          value: 'component__subcategory__category__category',
          sortable: false,
          align: 'center',
          divider: true,
          width: 100
        },
        {
          text: 'Case Package',
          value: 'component__case_package__name',
          sortable: false,
          align: 'center',
          divider: true,
          width: 80
        },
        {text: 'Image', value: 'component__image', sortable: false, align: 'center', divider: true, width: 60},
        {
          text: 'DataSheet',
          value: 'component__datasheet',
          sortable: false,
          align: 'center',
          divider: true,
          width: 10,
          type: 'link'
        },

        // {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
        // {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        // {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
        // {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
        {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 10},
      ],
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>